import { ColumnsType } from "antd/es/table";
import { Space, Dropdown } from "antd";
import { BotoesAcoes } from "../../ViewGerenciarPostagens/styles"; // Botões de ação
import SettingsIcon from "@mui/icons-material/Settings";
import { getMenuItems } from "../constants/itemsActionColumns";
import ColumnSearch from "../../../components/ColumnSearch";
import { Tag } from "antd";

export const Columns = (
  onClick: (e: any) => void,
  setEtiquetaId: (e: any) => void,
  filteredInfo: {
    nome?: string[] | null;
    descricao?: string[] | null;
    cor?: string[] | null;
    createAt?: string[] | null;
  }
): ColumnsType<any> => {
  const items = getMenuItems();

  return [
    {
      title: "Nome",
      dataIndex: "nome",
      key: "nome",
      width: "30%",
      filteredValue: filteredInfo.nome || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.nome.includes(value),
      ...ColumnSearch<any>({ dataIndex: "nome" }),
    },
    {
      title: "Descrição",
      dataIndex: "descricao",
      key: "descricao",
      width: "50%",
      filteredValue: filteredInfo.descricao || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.descricao.includes(value),
      ...ColumnSearch<any>({ dataIndex: "descricao" }),
    },
    {
      title: "Cor",
      dataIndex: "cor",
      key: "cor",
      width: "10%",
      align: "center",
      render: (cor: string, record) => (
        <div
          key={record.id || record.key} // ✅ adicionado: chave única
          style={{
            backgroundColor: cor || "#ccc",
            width: 24,
            height: 24,
            borderRadius: "50%",
            border: "1px solid #aaa",
            margin: "0 auto",
          }}
        />
      ),
    },

    {
      title: "Data de Criação",
      dataIndex: "createAt",
      key: "createAt",
      width: "20%",
      filteredValue: filteredInfo.createAt || null,
      onFilter: (value, record) => record.createAt.includes(value),
      ...ColumnSearch<any>({ dataIndex: "createAt" }),
    },
    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      width: "10%",
      align: "center",
      filteredValue: null,
      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                setEtiquetaId(row.key);
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];
};
